import { appendQueryString } from "../appendQueryString";
import type { Api } from "./api.types";

const mieterstromInvoicingApi = {
  contractFormOptions: {
    url: (projectId: string) =>
      appendQueryString("/api/contracts/get-choices/", {
        project: projectId
      }),
    key: (projectId: string) => ["contract-form-options", { projectId }]
  },
  contractSupplierGenerators: {
    url: ({ contractId, siteId }: { contractId: string; siteId: number }) =>
      appendQueryString(`/api/contracts/${contractId}/supplier_generators/`, {
        site: siteId
      }),
    key: ({ contractId, siteId }: { contractId: string; siteId: number }) => [
      "supplier-generators",
      { siteId, contractId }
    ]
  }
} satisfies Api;

const mieterstromInvoicingApiWithoutCamelization = {
  contract: {
    url: (id: string) => `/api/contracts/${id}/`,
    key: (id: string) => ["contract", { contractId: id }]
  },
  contracts: {
    url: (projectId: string) =>
      appendQueryString("/api/contracts/", {
        projectId: projectId
      }),
    key: (projectId: string) => ["contracts", { projectId }]
  },
  pendingInvoices: {
    url: (projectId: string) =>
      appendQueryString("/api/pending-invoices/", { projectId }),
    key: (projectId: string) => ["pendingInvoices", { projectId }]
  },
  invoiceExportGenerate: {
    url: ({
      projectId,
      dateFrom,
      dateTo,
      supplierId
    }: {
      projectId: string;
      dateFrom: string;
      dateTo: string;
      supplierId?: string;
    }) =>
      appendQueryString(`/api/invoice-export/${projectId}`, {
        date_from: dateFrom,
        date_to: dateTo,
        supplier_id: supplierId
      }),
    key: (projectId: string) => ["invoice-export", { projectId }]
  },
  invoiceExportResult: {
    url: ({ projectId, taskId }: { projectId: string; taskId: string }) =>
      appendQueryString(`/api/invoice-export/${projectId}`, {
        task_id: taskId
      }),
    key: ({ projectId, taskId }: { projectId: string; taskId: string }) => [
      "invoice-export-result",
      { projectId, taskId }
    ]
  }
} satisfies Api;

export { mieterstromInvoicingApi, mieterstromInvoicingApiWithoutCamelization };
